(function () {
  'use strict';

  // -------------------------------------------------------
  // Reveal-on-scroll (replaces AnimatedSection)
  // -------------------------------------------------------
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '-80px' });
    els.forEach(function (el) { io.observe(el); });
  }

  // -------------------------------------------------------
  // Countdown timers
  // -------------------------------------------------------
  function initCountdowns() {
    var nodes = document.querySelectorAll('[data-countdown]');
    if (!nodes.length) return;

    var instances = [];
    nodes.forEach(function (node) {
      var iso = node.getAttribute('data-target');
      if (!iso) return;
      var target = new Date(iso);
      if (isNaN(target.getTime())) return;
      instances.push({
        el: node,
        target: target,
        d: node.querySelector('[data-unit="days"] .countdown__value'),
        h: node.querySelector('[data-unit="hours"] .countdown__value'),
        m: node.querySelector('[data-unit="minutes"] .countdown__value'),
        s: node.querySelector('[data-unit="seconds"] .countdown__value')
      });
    });

    if (!instances.length) return;

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var now = Date.now();
      instances.forEach(function (i) {
        var diff = i.target.getTime() - now;
        if (diff <= 0) {
          if (i.d) i.d.textContent = '00';
          if (i.h) i.h.textContent = '00';
          if (i.m) i.m.textContent = '00';
          if (i.s) i.s.textContent = '00';
          return;
        }
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);
        if (i.d) i.d.textContent = pad(days);
        if (i.h) i.h.textContent = pad(hours);
        if (i.m) i.m.textContent = pad(minutes);
        if (i.s) i.s.textContent = pad(seconds);
      });
    }

    tick();
    setInterval(tick, 1000);
  }

  // -------------------------------------------------------
  // FAQ accordion
  // -------------------------------------------------------
  function initFAQ() {
    var lists = document.querySelectorAll('[data-faq-list]');
    lists.forEach(function (list) {
      var items = list.querySelectorAll('.faq-item');
      items.forEach(function (item) {
        var trigger = item.querySelector('.faq-item__trigger');
        if (!trigger) return;
        if (!item.hasAttribute('aria-expanded')) item.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', function () {
          var open = item.getAttribute('aria-expanded') === 'true';
          items.forEach(function (other) { other.setAttribute('aria-expanded', 'false'); });
          item.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
    });
  }

  // -------------------------------------------------------
  // Sources toggle
  // -------------------------------------------------------
  function initSources() {
    var sections = document.querySelectorAll('[data-sources]');
    sections.forEach(function (section) {
      var btn = section.querySelector('[data-sources-toggle]');
      if (!btn) return;
      section.setAttribute('data-open', 'false');
      btn.addEventListener('click', function () {
        var open = section.getAttribute('data-open') === 'true';
        section.setAttribute('data-open', open ? 'false' : 'true');
      });
    });
  }

  // -------------------------------------------------------
  // Mobile sticky CTA
  // RM 2026-08-06 (Marielle): show immediately on page load
  // (previously appeared only after scrolling past 600 px).
  // -------------------------------------------------------
  function initMobileSticky() {
    var el = document.querySelector('[data-mobile-cta]');
    if (!el) return;
    el.classList.add('is-visible');
  }

  // -------------------------------------------------------
  // Anchor scrolling fix
  // RM 2026-08-06 (Marielle): clicking CTA anchors (e.g. #bilety)
  // used to land on the wrong section — lazy-loaded images shift the
  // layout after the browser's instant jump. We scroll smoothly and
  // re-correct after images settle, so the target really is where
  // the visitor ends up.
  // -------------------------------------------------------
  function initAnchorScroll() {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var t = document.getElementById(id);
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(function () { t.scrollIntoView({ block: 'start' }); }, 900);
      setTimeout(function () { t.scrollIntoView({ block: 'start' }); }, 1800);
    }, true);
  }

  // -------------------------------------------------------
  // AJAX cart add + try to open parent theme's cart drawer.
  // -------------------------------------------------------
  function initCartAdd() {
    var section = document.getElementById('bilety');
    if (!section) return;

    var forms = section.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        handleAdd(form);
      });
    });
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.dataset.originalText = btn.textContent;
      btn.textContent = 'Dodaję...';
      btn.disabled = true;
      btn.style.opacity = '.7';
    } else {
      if (btn.dataset.originalText) btn.textContent = btn.dataset.originalText;
      btn.disabled = false;
      btn.style.opacity = '';
    }
  }

  async function handleAdd(form) {
    var btn = form.querySelector('button[type="submit"]');
    setButtonLoading(btn, true);

    var formData = new FormData(form);
    formData.delete('return_to');

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) {
        var err = await response.json().catch(function () { return {}; });
        throw new Error(err.description || err.message || 'Błąd dodawania do koszyka');
      }

      var item = await response.json();

      await refreshCartSections();

      tryOpenParentDrawer(item);

      setTimeout(function () {
        if (isAnyDrawerVisible()) {
          setButtonLoading(btn, false);
        } else {
          window.location.href = '/cart';
        }
      }, 600);
    } catch (e) {
      alert(e.message || 'Wystąpił błąd. Spróbuj ponownie.');
      setButtonLoading(btn, false);
    }
  }

  async function refreshCartSections() {
    var candidates = [
      'cart-drawer', 'cart-notification', 'cart-icon-bubble', 'cart',
      'mini-cart', 'header', 'header-cart', 'sidebar-cart', 'ajax-cart',
      'cart-template', 'cart-popup', 'pagefooter'
    ];

    var present = candidates.filter(function (id) {
      return document.querySelector('#shopify-section-' + id) ||
             document.querySelector('[id^="shopify-section-sections--"][id$="__' + id + '"]');
    });
    if (!present.length) return;

    try {
      var url = '/?sections=' + present.join(',');
      var resp = await fetch(url, { headers: { 'Accept': 'application/json' } });
      if (!resp.ok) return;
      var sections = await resp.json();

      Object.keys(sections).forEach(function (key) {
        var html = sections[key];
        if (!html || typeof html !== 'string') return;

        var oldEl = document.querySelector('#shopify-section-' + key) ||
                    document.querySelector('[id^="shopify-section-sections--"][id$="__' + key + '"]');
        if (!oldEl) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        oldEl.innerHTML = doc.body.innerHTML;
      });
    } catch (e) {
      // Silent fail — fallback redirect will handle UX
    }
  }

  function tryOpenParentDrawer(item) {
    var events = [
      'cart:refresh', 'cart:open', 'cart:added', 'cart:updated',
      'cart:change', 'ajaxProduct:added', 'product:added-to-cart',
      'shopify:cart:refresh', 'drawer:open'
    ];
    events.forEach(function (name) {
      try {
        document.dispatchEvent(new CustomEvent(name, { detail: { item: item }, bubbles: true }));
        window.dispatchEvent(new CustomEvent(name, { detail: { item: item } }));
      } catch (e) {}
    });

    var dawnDrawer = document.querySelector('cart-drawer');
    if (dawnDrawer && typeof dawnDrawer.open === 'function') {
      try { dawnDrawer.open(); } catch (e) {}
    }

    var globals = [
      window.cartDrawer, window.CartDrawer,
      window.theme && window.theme.cartDrawer,
      window.theme && window.theme.cart,
      window.Shopify && window.Shopify.theme && window.Shopify.theme.cartDrawer
    ];
    for (var i = 0; i < globals.length; i++) {
      if (globals[i] && typeof globals[i].open === 'function') {
        try { globals[i].open(); } catch (e) {}
      }
    }

    var trigger = document.querySelector(
      '[data-cart-drawer-toggle], [data-drawer-trigger="cart"],' +
      'button[aria-controls*="cart-drawer"], button[data-cart-open]'
    );
    if (trigger && typeof trigger.click === 'function') {
      try { trigger.click(); } catch (e) {}
    }
  }

  function isAnyDrawerVisible() {
    var selectors = [
      'cart-drawer[open]',
      'cart-drawer.active',
      'cart-drawer.is-open',
      '.cart-drawer.is-open',
      '.cart-drawer.active',
      '.cart-drawer--open',
      '.cart-drawer.open',
      '.drawer.is-open',
      '.drawer--cart.is-open',
      '[class*="cart-drawer"][class*="open"]',
      '[class*="cart-drawer"][aria-hidden="false"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var els = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < els.length; j++) {
        if (isVisiblyOpen(els[j])) return true;
      }
    }
    return false;
  }

  function isVisiblyOpen(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    if (parseFloat(cs.opacity) < 0.1) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  // -------------------------------------------------------
  // Hero video
  // -------------------------------------------------------
  function initHeroVideo() {
    var v = document.querySelector('[data-hero-video]');
    if (!v) return;
    v.addEventListener('loadedmetadata', function () { try { v.currentTime = 0; } catch (e) {} });
    v.addEventListener('ended', function () {
      try { v.currentTime = 0; v.play(); } catch (e) {}
    });
  }

  // -------------------------------------------------------
  // Boot
  // -------------------------------------------------------
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initReveal();
    initCountdowns();
    initFAQ();
    initSources();
    initMobileSticky();
    initAnchorScroll();
    initHeroVideo();
    initCartAdd();
  });
})();
